export default __webpack_public_path__ + "loading 2x.svg";